@if (action == 'index') {
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="fs-2 fw-light mt-4">Choose Property - Complaints</h1>
      <button (click)="goHome()" class="btn btn-primary">Home <fa-icon [icon]="faHouseChimney"></fa-icon></button>
    </div>

    <div class="form-group has-search my-3">
      <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
      <input type="text" name="searchProperty" [(ngModel)]="searchProperty" class="form-control" placeholder="Search by property name" />
    </div>

    @if (loadingProperties) {
      <div class="my-4">
        <span class="spinner-border spinner-border-sm mr-1"></span>
        <span>Loading properties...</span>
      </div>
    }

    @if (!loadingProperties && properties.length == 0) {
      <div class="alert alert-info">No properties found.</div>
    }

    <ul class="list-group list-group-flush col-md-6">
      @for (property  of properties | filter: searchProperty ; track property ) {
        <li (click)="onSelectedProperty(property)" class="fs-3 text-primary list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          @if (property.property_type == 'house') {
            <fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
          }
          @if (property.property_type == 'strata') {
            <fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
          }
          @if (property.property_type == 'Townhouse') {
            <fa-icon class="l-icon" [icon]="faHouseChimney"></fa-icon>
          }
          <span class="text-black fw-lighter">{{property.name}} </span>
          <fa-icon [icon]="faCircleArrowRight"></fa-icon>
        </li>
      }
    </ul>
  </div>
}

@if (action != 'index' && !property?.id) {
  <div class="container">
    <h1 class="fs-2 fw-light mt-4">Manage Complaints</h1>
    <div class="alert alert-warning mt-4">
      No property selected. Choose a property first to manage complaints.
    </div>
    <button (click)="goBack()" type="button" class="btn btn-primary">
      <fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
    </button>
  </div>
}

@if (action != 'index' && property?.id && properties.length > 1) {
  <div class="container mt-3">
    <button (click)="onChangeProperty()" type="button" class="btn btn-sm btn-outline-secondary">Change property</button>
  </div>
}

@if (property?.id && action == 'create') {
  <div class="container">
    <h1 class="fs-2 fw-light mt-4">Create Complaint</h1>
    <form [formGroup]="addComplaintForm">
      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complainantName">Complainant Name</label>
          <input class="form-control" id="complainantName" type="text" formControlName="name_complainant" [ngClass]="{ 'is-invalid': submitComplaintData && fca.name_complainant.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complainantEmail">Complainant Email</label>
          <input class="form-control" id="complainantEmail" type="email" formControlName="complainant_email" [ngClass]="{ 'is-invalid': submitComplaintData && fca.complainant_email.errors }" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complainantAddress">Complainant Address</label>
          <input class="form-control" id="complainantAddress" type="text" formControlName="address_complainant" [ngClass]="{ 'is-invalid': submitComplaintData && fca.address_complainant.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complainantType">Complainant Type</label>
          <input class="form-control" id="complainantType" type="text" formControlName="complainant_type" [ngClass]="{ 'is-invalid': submitComplaintData && fca.complainant_type.errors }" />
        </div>
      </div>

      <div class="form-group my-2">
        <label class="form-label" for="complainantLotNo">Complainant Section/Strata Lot No</label>
        <input class="form-control" id="complainantLotNo" type="text" formControlName="complainant_section_strata_lotno" [ngClass]="{ 'is-invalid': submitComplaintData && fca.complainant_section_strata_lotno.errors }" />
      </div>

      <hr class="my-4" />

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complaineeName">Complainee Name</label>
          <input class="form-control" id="complaineeName" type="text" formControlName="name_complainee" [ngClass]="{ 'is-invalid': submitComplaintData && fca.name_complainee.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complaineeEmail">Complainee Email</label>
          <input class="form-control" id="complaineeEmail" type="email" formControlName="complainee_email" [ngClass]="{ 'is-invalid': submitComplaintData && fca.complainee_email.errors }" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complaineeAddress">Complainee Address</label>
          <input class="form-control" id="complaineeAddress" type="text" formControlName="address_complainee" [ngClass]="{ 'is-invalid': submitComplaintData && fca.address_complainee.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="complaineeLotNo">Complainee Section/Strata Lot No</label>
          <input class="form-control" id="complaineeLotNo" type="text" formControlName="complainee_section_strata_lotno" [ngClass]="{ 'is-invalid': submitComplaintData && fca.complainee_section_strata_lotno.errors }" />
        </div>
      </div>

      <hr class="my-4" />

      <div class="form-group my-3">
        <label class="form-label" for="groundsComplaint">Grounds of Complaint</label>
        <textarea class="form-control" id="groundsComplaint" rows="5" formControlName="grounds_complaint" [ngClass]="{ 'is-invalid': submitComplaintData && fca.grounds_complaint.errors }"></textarea>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="dateSubmission">Date of Submission</label>
          <input class="form-control" id="dateSubmission" type="date" formControlName="date_submission" [ngClass]="{ 'is-invalid': submitComplaintData && fca.date_submission.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="status">Status</label>
          @if (canEditStatus()) {
            <select class="form-select" id="status" formControlName="status" [ngClass]="{ 'is-invalid': submitComplaintData && fca.status.errors }">
              <option [value]="ComplaintStatus.Capture">Capture</option>
              <option [value]="ComplaintStatus.Acknowledge">Acknowledge</option>
              <option [value]="ComplaintStatus.Categorize">Categorize</option>
              <option [value]="ComplaintStatus.Investigate">Investigate</option>
              <option [value]="ComplaintStatus.Escalate">Escalate</option>
              <option [value]="ComplaintStatus.Resolve">Resolve</option>
              <option [value]="ComplaintStatus.Close">Close</option>
            </select>
          } @else {
            <input type="text" class="form-control" [value]="getComplaintStatusLabel(ComplaintStatus.Capture)" readonly />
            <input type="hidden" formControlName="status" [value]="ComplaintStatus.Capture" />
          }
        </div>
      </div>

      <div class="form-group my-3">
        <label class="form-label" for="propertyName">Property</label>
        <input class="form-control" id="propertyName" type="text" formControlName="propertyName" readonly />
        <input type="hidden" formControlName="propertyId" />
      </div>
    </form>
  </div>
}

@if (property?.id && action == 'edit') {
  <div class="container">
    <h1 class="fs-2 fw-light mt-4">Edit Complaint</h1>
    <form [formGroup]="editComplaintForm">
      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplainantName">Complainant Name</label>
          <input class="form-control" id="editComplainantName" type="text" formControlName="name_complainant" [ngClass]="{ 'is-invalid': submitComplaintData && fce.name_complainant.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplainantEmail">Complainant Email</label>
          <input class="form-control" id="editComplainantEmail" type="email" formControlName="complainant_email" [ngClass]="{ 'is-invalid': submitComplaintData && fce.complainant_email.errors }" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplainantAddress">Complainant Address</label>
          <input class="form-control" id="editComplainantAddress" type="text" formControlName="address_complainant" [ngClass]="{ 'is-invalid': submitComplaintData && fce.address_complainant.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplainantType">Complainant Type</label>
          <input class="form-control" id="editComplainantType" type="text" formControlName="complainant_type" [ngClass]="{ 'is-invalid': submitComplaintData && fce.complainant_type.errors }" />
        </div>
      </div>

      <div class="form-group my-2">
        <label class="form-label" for="editComplainantLotNo">Complainant Section/Strata Lot No</label>
        <input class="form-control" id="editComplainantLotNo" type="text" formControlName="complainant_section_strata_lotno" [ngClass]="{ 'is-invalid': submitComplaintData && fce.complainant_section_strata_lotno.errors }" />
      </div>

      <hr class="my-4" />

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplaineeNname">Complainee Name</label>
          <input class="form-control" id="editComplaineeNname" type="text" formControlName="name_complainee" [ngClass]="{ 'is-invalid': submitComplaintData && fce.name_complainee.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplaineeEmail">Complainee Email</label>
          <input class="form-control" id="editComplaineeEmail" type="email" formControlName="complainee_email" [ngClass]="{ 'is-invalid': submitComplaintData && fce.complainee_email.errors }" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplaineeAddress">Complainee Address</label>
          <input class="form-control" id="editComplaineeAddress" type="text" formControlName="address_complainee" [ngClass]="{ 'is-invalid': submitComplaintData && fce.address_complainee.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editComplaineeLotnNo">Complainee Section/Strata Lot No</label>
          <input class="form-control" id="editComplaineeLotnNo" type="text" formControlName="complainee_section_strata_lotno" [ngClass]="{ 'is-invalid': submitComplaintData && fce.complainee_section_strata_lotno.errors }" />
        </div>
      </div>

      <hr class="my-4" />

      <div class="form-group my-3">
        <label class="form-label" for="editGroundsComplaint">Grounds of Complaint</label>
        <textarea class="form-control" id="editGroundsComplaint" rows="5" formControlName="grounds_complaint" [ngClass]="{ 'is-invalid': submitComplaintData && fce.grounds_complaint.errors }"></textarea>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editDateSubmission">Date of Submission</label>
          <input class="form-control" id="editDateSubmission" type="date" formControlName="date_submission" [ngClass]="{ 'is-invalid': submitComplaintData && fce.date_submission.errors }" />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label" for="editStatus">Status</label>
          @if (canEditStatus()) {
            <select class="form-select" id="editStatus" formControlName="status" [ngClass]="{ 'is-invalid': submitComplaintData && fce.status.errors }">
              <option [value]="ComplaintStatus.Capture">Capture</option>
              <option [value]="ComplaintStatus.Acknowledge">Acknowledge</option>
              <option [value]="ComplaintStatus.Categorize">Categorize</option>
              <option [value]="ComplaintStatus.Investigate">Investigate</option>
              <option [value]="ComplaintStatus.Escalate">Escalate</option>
              <option [value]="ComplaintStatus.Resolve">Resolve</option>
              <option [value]="ComplaintStatus.Close">Close</option>
            </select>
          } @else {
            <input type="text" class="form-control" [value]="getComplaintStatusLabel(editComplaintForm.get('status')?.value)" readonly />
          }
        </div>
      </div>

      <div class="form-group my-3">
        <label class="form-label" for="editPropertyName">Property</label>
        <input class="form-control" id="editPropertyName" type="text" formControlName="propertyName" readonly />
        <input type="hidden" formControlName="propertyId" />
      </div>
    </form>
  </div>
}

@if (property?.id && action == 'view') {
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="fs-2 fw-light mt-4">View Complaint</h1>
      <button (click)="onEditComplaint()" type="button" class="mt-4 btn btn-primary">
        Edit <fa-icon [icon]="faPenToSquare"></fa-icon>
      </button>
    </div>

    <form [formGroup]="viewComplaintForm">
      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainant Name</label>
          <input class="form-control" type="text" formControlName="name_complainant" readonly />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainant Email</label>
          <input class="form-control" type="email" formControlName="complainant_email" readonly />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainant Address</label>
          <input class="form-control" type="text" formControlName="address_complainant" readonly />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainant Type</label>
          <input class="form-control" type="text" formControlName="complainant_type" readonly />
        </div>
      </div>

      <div class="form-group my-2">
        <label class="form-label">Complainant Section/Strata Lot No</label>
        <input class="form-control" type="text" formControlName="complainant_section_strata_lotno" readonly />
      </div>

      <hr class="my-4" />

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainee Name</label>
          <input class="form-control" type="text" formControlName="name_complainee" readonly />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainee Email</label>
          <input class="form-control" type="email" formControlName="complainee_email" readonly />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainee Address</label>
          <input class="form-control" type="text" formControlName="address_complainee" readonly />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Complainee Section/Strata Lot No</label>
          <input class="form-control" type="text" formControlName="complainee_section_strata_lotno" readonly />
        </div>
      </div>

      <hr class="my-4" />

      <div class="form-group my-3">
        <label class="form-label">Grounds of Complaint</label>
        <textarea class="form-control" rows="5" formControlName="grounds_complaint" readonly></textarea>
      </div>

      <div class="row">
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Date of Submission</label>
          <input class="form-control" type="date" formControlName="date_submission" readonly />
        </div>
        <div class="col-md-6 form-group my-2">
          <label class="form-label">Status</label>
          <input class="form-control" type="text" formControlName="status" readonly />
        </div>
      </div>

      <div class="form-group my-3">
        <label class="form-label">Property</label>
        <input class="form-control" type="text" formControlName="propertyName" readonly />
      </div>
    </form>
  </div>
}

@if (property?.id && action == 'list') {
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="fs-2 fw-light mt-4">Manage Complaints</h1>
      <button (click)="onCreateComplaint()" type="button" class="mt-4 btn btn-primary">
        Add <fa-icon [icon]="faCirclePlus"></fa-icon>
      </button>
    </div>

    <p class="text-muted">Property: {{ property.name }}</p>

    <div class="form-group has-search my-3">
      <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
      <input type="text" name="searchComplaint" [(ngModel)]="searchComplaint" class="form-control" placeholder="Search complaints" />
    </div>

    @if (loading) {
      <div class="my-4">
        <span class="spinner-border spinner-border-sm mr-1"></span>
        <span>Loading complaints...</span>
      </div>
    }

    @if (!loading && complaints.length == 0) {
      <div class="alert alert-info">No complaints found for this property. Create your first complaint.</div>
    }

    <ul class="list-group list-group-flush">
      @for (complaint of complaints; track complaint.id) {
        @if ((complaint.name_complainant + ' ' + complaint.name_complainee + ' ' + complaint.grounds_complaint).toLowerCase().includes(searchComplaint.toLowerCase())) {
          <li class="list-group-item">
            <button class="btn btn-link text-start p-0 text-decoration-none w-100" type="button" (click)="onSelectedComplaint(complaint)">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <strong class="text-primary">{{ complaint.name_complainant }} vs {{ complaint.name_complainee }}</strong>
                  <div class="text-muted small mt-1">{{ complaint.grounds_complaint }}</div>
                  <div class="text-secondary small mt-1">Status: {{ getComplaintStatusLabel(complaint.status) }} | Submitted: {{ complaint.date_submission | date: 'MMM d, y' }}</div>
                </div>
                <fa-icon [icon]="faCircleArrowRight"></fa-icon>
              </div>
            </button>
          </li>
        }
      }
    </ul>
  </div>
}

@if (property?.id) {
  <div class="mt-4 d-flex container justify-content-between align-items-center">
    <button (click)="goBack()" type="button" class="btn btn-primary">
      <fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
    </button>

    @if (action == 'create') {
      <button [disabled]="fetching" class="btn btn-primary" (click)="createComplaint()">
        Save
        @if (!fetching) {
          <fa-icon [icon]="faPaperPlane"></fa-icon>
        }
        @if (fetching) {
          <span class="spinner-border spinner-border-sm mr-1"></span>
        }
      </button>
    }

    @if (action == 'edit') {
      <div class="d-flex gap-2">
        <button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteComplaint()">
          Delete <fa-icon [icon]="faTrash"></fa-icon>
        </button>
        <button [disabled]="fetching" class="btn btn-info" (click)="updateComplaint()">
          Update
          @if (!fetching) {
            <fa-icon [icon]="faPaperPlane"></fa-icon>
          }
          @if (fetching) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
        </button>
      </div>
    }

    @if (action == 'view') {
      <button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteComplaint()">
        Delete <fa-icon [icon]="faTrash"></fa-icon>
      </button>
    }
  </div>
}
